import {Injectable} from '@angular/core';
import {FabricService} from 'src/app/services/fabric/fabric.service';

const SERVICE_NAME = 'mgmt-backup-resources';

@Injectable({
  providedIn: 'root'
})
export class BackupService {

  constructor(private fabricService: FabricService) {

  }

  putInstanceBackup(form: any): any {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'put_mgmt_instances_id_backup', form);
  }

  getInstanceBackupResults(id, size?): any {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'get_mgmt_instances_id_backup-results', {id, size});
  }

  deleteInstanceBackupResults(id, backupResultId): any {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'delete_mgmt_instances_id_backup-delete_backupresultid', {id, backupResultId});
  }

  putExtendExpiry(form: any): any {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'put_mgmt_instances_id_backup-results_backupresultid_extend-expiry', form);
  }
  
}
